import React, { useEffect, useState } from "react";
import "./CategorySections.css";
import CategoryCard from "../../components/Cards/CategoryCard";
import api from "../../api";
import { Category } from "../../api.response";
import { useNavigate } from "react-router-dom";
import { PaginatedResponse } from "@flooron/shared";

interface CategorySectionProps {
  title?: string;
}

const CategorySection: React.FC<CategorySectionProps> = ({
  title = "Our Categories",
}) => {
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState<Category[]>([]);
  const navigate = useNavigate();

  const handleFetchCategories = async () => {
    try {
      const response: PaginatedResponse<Category> = await api.getCategories();

      setCategories(response.data);
    } catch (err) {
      console.error("Failed to fetch categories", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleFetchCategories();
  }, []);

  return (
    <section className="category-section">
      <h2 className="category-section-title">{title}</h2>
      <div className="categories-container">
        {loading
          ? [...Array(4)].map((_, i) => (
              <CategoryCard
                id={`loading-${i}`}
                key={`loading-${i}`}
                imageUrl="https://htmlcolorcodes.com/assets/images/colors/light-gray-color-solid-background-1920x1080.png"
                title="Category"
              />
            ))
          : categories.map((cat) => (
              <CategoryCard
                id={cat.id.toString()}
                key={cat.id}
                imageUrl={`https://api.flooron.in/${cat.image}`}
                title={cat.title}
                onClick={() => {
                  navigate(`category/${cat.id.toString()}`);
                }}
              />
            ))}
      </div>
    </section>
  );
};

export default CategorySection;
